<template>
  <div id="re_list">
    <van-nav-bar
      title="工人列表"
      left-text="返回"
      left-arrow
      right-text="新增工人"
      @click-left="onClickLeft"
      @click-right="selectWorkers"
    />
    <div v-for="(item, index) in workerList" :key="index" class="loading_list loading_list_item" @click="showDetail(item)">
      <div class="loading_list_content">
        <div class="loading_list_brand"><span style="width: 80px; display: inline-block">姓 名: </span>{{ item.worker_name }} </div>
        <div class="loading_list_city"><span style="width: 80px; display: inline-block">手机号: </span>{{ item.worker_mobile }} </div>
        <div class="loading_list_id_card"><span style="width: 80px; display: inline-block">身份证号: </span>{{ item.id_card_no }}</div>
        <div class="loading_list_item" style="margin: 0;">
          <div>证件信息</div>
          <div style="margin: 10px 0;">
            身份证:<van-icon v-if="item.id_card === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.id_card === 'n'" name="cross" color="#ee0a24" />|健康码:<van-icon v-if="item.health_qrcode === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.health_qrcode === 'n'" name="cross" color="#ee0a24" />|
            行程码:<van-icon v-if="item.travel_qrcode === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.travel_qrcode === 'n'" name="cross" color="#ee0a24" />|核酸检测:<van-icon v-if="item.nucleic_acid_report === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.nucleic_acid_report === 'n'" name="cross" color="#ee0a24" />|通行证:<van-icon v-if="item.pass_card === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.pass_card === 'n'" name="cross" color="#ee0a24" />|
            电工证:<van-icon v-if="item.electrician_certificate === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.electrician_certificate === 'n'" name="cross" color="#ee0a24" />|制冷证:<van-icon v-if="item.refrigeration_certificate === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.refrigeration_certificate === 'n'" name="cross" color="#ee0a24" />|
            高空证:<van-icon v-if="item.high_altitude_certificate === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.high_altitude_certificate === 'n'" name="cross" color="#ee0a24" />|焊工证:<van-icon v-if="item.welder_certificate === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.welder_certificate === 'n'" name="cross" color="#ee0a24" />|
            其他证件:<van-icon v-if="item.other_certificate === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.other_certificate === 'n'" name="cross" color="#ee0a24" />|
            保险单:<van-icon v-if="item.policy === 'y'" color="#1989fa" name="success" /><van-icon v-if="item.policy === 'n'" name="cross" color="#ee0a24" />
          </div>
        </div>
      </div>
      <div class="loading_list_delete" style="position: absolute; right: 10px; top: 2px;" @click.stop="changeCheckedStatus">
        <van-field name="checkbox" label="">
          <template #input>
            <van-checkbox v-model="item.checked" shape="square" icon-size="26px" />
          </template>
        </van-field>
      </div>
    </div>
    <div style="height: 80px; "></div>
    <div style="position: fixed; right: 0px; bottom: 10px; width: 100%;">
      <van-button @click="submitTask(true)" v-if="workerList.length > 0"  style="width: 100px" type="primary" size="normal">预览</van-button>
      <van-button @click="submitTask(false)" v-if="workerList.length > 0" style="width: 100px"  type="info" size="normal">提交</van-button>
      <!--<div @click="preview" v-if="workerList.length > 0" style="line-height: 50px; text-align: center; color: #FFFFFF; width: 100px; height: 40px; float: left; background: #3a8ee6;">预览</div>
      <div @click="submitTask" v-if="workerList.length > 0" style=" line-height: 50px; text-align: center; color: #FFFFFF; width: 50px; height: 50px; float: left; background: #3a8ee6;">提交</div>-->
    </div>
  </div>
</template>

<script>
import {
  getCooperateWorkerList,
  workerDeleteWorkerInfoReport,
  workerSubmitConstructionReport,
  workerSubmitConstructionReportNew
} from "../../../api/user";
import {Toast} from "vant";

const STATUS = ['', '待接受', '已提交', '待维修', '已完工', '待验收', '验收通过', '待返工']
const REPAIR_TYPES = ['定期维保', '紧急维修', '改造工程']

const COLOR_TAG_TYPES = {
  yellow: 'warning',
  red: 'danger',
  green: 'success',
  blue: 'primary'
}

export default {
  name: 'OrderWorkers',
  data () {
    return {
      value2: '',
      active: 0,
      statusOptions: [],
      option2: [],
      finished: '',
      loading: false,
      list: [],
      workerList: [],
      color_tag_types: COLOR_TAG_TYPES
    }
  },
  created () {
    this.initList()
  },
  methods: {
    changeCheckedStatus() {
      this.$forceUpdate()
    },
    preview() {
      window.open('#/worker_pdf?appo_task_id=' + this.$route.query.appo_task_id + '&contact_person_type=same&company_id=' + 1, '_blank')
    },
    submitTask(preview) {
      console.log('workerList', this.workerList)
      const postData = {
        appo_task_id: this.$route.query.appo_task_id,
        worker_list: []
      }
      for (const item in this.workerList) {
        if (this.workerList[item].checked) {
          postData.worker_list.push({
            worker_uid: this.workerList[item].worker_uid,
            worker_info_report_id: this.workerList[item].worker_info_report_id
          })
        }
      }
      workerSubmitConstructionReportNew(postData).then((res) => {
        if (res.data.code === 0) {
          Toast('提交成功')
          if (preview) {
            window.open('#/worker_pdf?appo_task_id=' + this.$route.query.appo_task_id + '&contact_person_type=same&company_id=' + 1, '_blank')
          }
          return false
        }
      })
    },
    deleteWorker(item) {
      console.log('item.....', item)
      if (item.id > 0) {
        workerDeleteWorkerInfoReport({worker_info_report_id: item.id})
        this.initList()
      }
    },
    async initList () {
      getCooperateWorkerList({appo_task_id: this.$route.query.appo_task_id}).then((res) => {
        console.log('res..........', res.data.data)
        if (res.data.data) {
          this.workerList = []
          for (const i in res.data.data) {
            const result = res.data.data[i]
            if(typeof res.data.data[i].worker_info_report_id !== 'undefined' && res.data.data[i].worker_info_report_id) {
              result.checked = true
            } else {
              result.checked = false
            }
            this.workerList.push(result)
          }
        }
      })
    },
    onLoad () {
      setTimeout(() => {
        if (this.finished) {
          return false
        }
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
        }
        this.initList(this.page + 1)
        this.loading = false
      }, 1000)
    },
    onRefresh () {
      if (this.finished) {
        return false
      }
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    onClickLeft () {
      this.$router.push({path: '/index'})
    },
    showReport (id, val) {
      this.$router.push({path:'/warranty_detail', query: {id: id, annex_id: val.annex_id}})
    },
    changeStatus (val) {
      this.checkStatus = val
      this.list = []
      this.finished = false
      this.initList(1, val, this.value2)
    },
    changeSort (val) {
      this.value2 = val
      this.list = []
      this.initList(1, this.checkStatus, val)
    },
    selectWorkers() {
      this.$router.push({ path: '/order_select_worker', query: { appo_task_id: this.$route.query.appo_task_id }})
    },
    showDetail(item) {
      this.$router.push({path: '/order_select_worker', query: { appo_task_id: this.$route.query.appo_task_id, worker_uid: item.worker_uid, worker_name: item.worker_name, worker_mobile: item.worker_mobile, worker_info_report_id: item.id }})
    }
  }
}
</script>

<style scoped>
#re_list {
  background: #F5F5F5;
}
.loading_list {
  background-color: #fff;
  margin: 10px 5px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.loading_list_item {
  width: 96%;
  margin: 5px auto;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 10px;
}
.loading_list_header { overflow: hidden; padding-top: 10px; padding-right: 2%; }
.loading_list_code { float: left; color: #000000; font-weight: 500; width: 60%; font-size: 16px; height: 20px; text-align: left;padding-left: 5%; }
.loading_list_status { float: right !important; text-align: right; width: 30%; font-size: 14px; height: 16px; }
.loading_list_content { overflow: hidden; text-align: left; padding-left: 5%; margin: 6px auto; font-size: 14px; color: #717989;}
.loading_list_content_left { float: left; width: 40%; padding-left: 5%; text-align: left; }
.loading_list_content_right { float: right; text-align: left; width: 50%; }
.loading_list_bottom_text {
  font-size: 12px; text-align: right;
  height: 15px;
  float: right;
  width: 35%;
}
.loading_list_job_type {
  font-size: 14px;
  color: #717989;
}
.loading_list_bottom {
  padding: 0 5% 10px;
}
.loading_list_bottom div {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/order-workers.vue